<template>
  <div class="UnitList">
    <div class="bg_black text_white">
      <div class="ninew bodybox">
        <van-nav-bar
          left-arrow
          fixed
          @click-left="goback"
          :title="$t('itemInfo.unitTitle')"
        >
          <van-icon
            name="./static/img/add_staff.png"
            slot="right"
            @click="$router.push('/AddUnitList')"
            style="font-size: 24px"
          />
        </van-nav-bar>
      </div>
    </div>
    <!-- 物品信息表 -->
    <div class="ninew bodybox twentyTop">
      <div v-if="unitList.length > 0" v-cloak>
        <van-cell-group>
          <van-cell>
            <van-row>
              <van-col span="8">{{ $t("itemInfo.unitName") }}</van-col>
              <van-col span="8">{{ $t("itemInfo.unitsymbol") }}</van-col>
              <van-col span="8">{{ $t("itemInfo.time") }}</van-col>
            </van-row>
            <div slot="right-icon" style="width: 22px"></div>
          </van-cell>
          <template v-for="(item, index) in unitList">
            <van-cell center is-link @click="editInfo(item.id)">
              <van-row>
                <van-col span="8">{{ item.name }}</van-col>
                <van-col span="8">{{ item.symbol }}</van-col>
                <van-col span="8">{{ item.updated_at }}</van-col>
              </van-row>
            </van-cell>
          </template>
        </van-cell-group>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      unitList: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    goback() {
      this.$router.go(-1); //返回上一层
    },
    editInfo(id){
      this.$router.push({ path: "/AddUnitList", query: { id: id } });
    },
    getList() {
      // 獲取物品信息表
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url:
          this.$build +
          `/api/unit/index`,
      })
        .then((res) => {
          if (res.data.status == 200) {
            console.log(res.data.data, "獲取所有单位");
            this.unitList = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {});
    },
    bindStock(type, id) {
      console.log(type, id);
      this.$router.push({
        path: "/UnitManage",
        query: { id: id, status: type },
      });
    },
  },
};
</script>

<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-nav-bar__left {
  padding: 0;
  left: -4px;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
/deep/ .van-cell-group--inset {
  margin: 0;
  margin-top: 15px;
}
.twentyTop {
  margin-top: 0;
}
</style>


// WEBPACK FOOTER //
// src/Platform/UnitList.vue